import { Object3D, Euler, Quaternion, Vector3 } from 'three';
import { Model } from './Model';

export class Scene extends Model{

	setDefaultView(){

		if(this.data && this.data.camera){
			const camera = this.viewer.rendering.camera;
			const cameraData = this.data.camera;
			camera.position.set(
				cameraData.position.x,
				cameraData.position.y,
				cameraData.position.z
			);
			camera.rotation.set(
				cameraData.rotation.x,
				cameraData.rotation.y,
				cameraData.rotation.z
			);

			this.viewer.requestRender();
			return true;
		}
		return false;
	}
}